module.exports = __webpack_public_path__ + "static/media/pathogym.02254bf7.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/pathogym.PNG
// module id = 89
// module chunks = 0